import { type ReactElement } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '../terros/icon/MaterialSymbolIcon'
import { TButton, type TButtonProps } from '../buttons'

type Props = Omit<TButtonProps, 'onClick'> & {
  children?: ReactElement | string
}

export const ButtonSignOut = ({ children, rightSection, icon, ...props }: Props): ReactElement => {
  const { logout } = useAuth0()
  const { t } = useTranslation()

  return (
    <TButton
      icon={icon}
      rightSection={rightSection ?? (icon ? undefined : <MaterialSymbolIcon icon='exit_to_app' size={14} />)}
      variant='secondary'
      onClick={() => logout({ logoutParams: { returnTo: `${window.location.origin}/` } })}
      {...props}
    >
      {children ?? t('Sign Out')}
    </TButton>
  )
}
